import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { LinearProgress, TableFooter, TablePagination, TableSortLabel } from "@material-ui/core";
import FTLStyledTableCellComponent from "./FTLStyledTableCellComponent";
import FTLStyledTableRowComponent from "./FTLStyledTableRowComponent";
import FTLTablePaginationActionsComponent from "./FTLTablePaginationActionsComponent";
import FTLPureTableStyle from "../styles/FTLPureTableStyle";
export default function FTLPureTableComponent({ classes = FTLPureTableStyle(), page = 0, rowsPerPage = 10, total = 0, metadata, data, isLoading = false, onChangePage, onChangeRowsPerPage, onClickRow, onClickHeaderCell }) {
    return (React.createElement(React.Fragment, null,
        isLoading ? React.createElement(LinearProgress, { color: 'secondary' }) : React.createElement("div", { style: { width: '100%', height: '4px' } }),
        React.createElement(TableContainer, null,
            React.createElement(Table, { className: classes.table, size: "small", "aria-label": "custom pagination  a dense table " },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, metadata.map((headRow) => {
                        return (React.createElement(FTLStyledTableCellComponent, Object.assign({ key: headRow.id, sortDirection: headRow.sortDirection }, headRow.propsHeader),
                            React.createElement(TableSortLabel, { onClick: () => {
                                    onClickHeaderCell != undefined && onClickHeaderCell(headRow);
                                }, active: headRow.sortDirection ? true : false, direction: headRow.sortDirection == undefined ?
                                    undefined :
                                    (headRow.sortDirection == 'asc' ?
                                        'asc' :
                                        'desc') },
                                headRow.headerName,
                                React.createElement("span", { className: classes.visuallyHidden }, headRow.sortDirection == "asc" ?
                                    "sorted asc" :
                                    "sorted descending"))));
                    }))),
                React.createElement(TableBody, null, data.map((dataItem, index) => {
                    return (React.createElement(FTLStyledTableRowComponent, { key: `table-row-${index}`, onClick: () => onClickRow ? onClickRow(dataItem) : false }, metadata.map((headData, indexCell) => {
                        return (React.createElement(FTLStyledTableCellComponent, Object.assign({ key: `table-cell-${indexCell}`, component: "th", scope: "row" }, headData.propsBody), headData.renderCell(dataItem)));
                    })));
                })),
                React.createElement(TableFooter, null,
                    React.createElement(TableRow, null,
                        React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25, { label: 'All', value: -1 }], colSpan: 5, count: total, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                            }, 
                            // @ts-ignore
                            onPageChange: (event, newPage) => {
                                onChangePage(newPage);
                            }, onRowsPerPageChange: (event) => {
                                onChangeRowsPerPage(parseInt(event.target.value, 10));
                            }, ActionsComponent: FTLTablePaginationActionsComponent, align: 'right' })))))));
}
//# sourceMappingURL=FTLPureTableComponent.js.map